import React from 'react';
import {AppBanner} from '@homeaway/react-app-banner';
import Experiment from '@homeaway/react-experiment';
import {Notification} from '@homeaway/react-customer-notification';
import {isWebview} from '../../utils/browserUtils';
import 'isomorphic-unfetch';
import {
    BOOKINGS,
    CONFIRMATION,
    INBOX,
    MY_TRIPS,
} from '../../utils/appConfigData';

function AppDownloadBanner({systemData, path}) {
    const {isAndroid} = systemData.deviceOSType || {};
    const mobileOS = isAndroid ? 'android' : 'ios';
    const siteName = systemData.site?.name;

    const getRouteFrom = (pathName = '') => {
        if (pathName.includes(INBOX)) {
            return INBOX;
        } else if (pathName.includes(BOOKINGS)) {
            return MY_TRIPS;
        } else if (pathName.includes(CONFIRMATION)) {
            return CONFIRMATION;
        }
        return null;
    };
    const pageName = {
        confirmation: 'CONFIRMATION',
        inbox: 'FEATURES',
        mytrips: 'POST_BOOKING',
    };
    const experimentNames = {
        confirmation: 'Vrbo_MAD_Booking_Confirmation_placement_surface_gate',
        inbox: 'Vrbo_MAD_Inbox_placement_surface_gate',
        mytrips: 'Vrbo_MAD_myTrips_placement_surface_gate',
    };
    const page = getRouteFrom(path);
    const funnelLocation = pageName[page];
    const experimentName = experimentNames[page];
    const isNativeApp = isWebview(systemData.userAgent);

    return (
        systemData.isMobile &&
        !isNativeApp &&
        page && (
            <React.Fragment>
                <Experiment name={experimentName} variant={'on'}>
                    <Notification
                        funnelLocation={funnelLocation}
                        locale={systemData.fullLocale}
                        notificationLocation="PRE_HEADER"
                        siteName={siteName}
                    />
                </Experiment>
                <Experiment name={experimentName} variant={'off'}>
                    <AppBanner
                        locale={systemData.fullLocale}
                        mobileOS={mobileOS}
                        page={page}
                    />
                </Experiment>
            </React.Fragment>
        )
    );
}

AppDownloadBanner.defaultProps = {
    systemData: {},
};

export default AppDownloadBanner;
